import { CatalogueEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";
import "./all";
import * as CarouselAddToBagButtonsContainer from "../common/containers/CarouselAddToBagButtonsContainer";
import StyleSubscriptionAvailabilityService from "../common/services/StyleSubscriptionAvailabilityService";
import { DATE_PICKER_EVENTS } from "../core/constants";
import Visitor from "./visitor";
import Page from "./Page";
import InDevFeatureFlags, { initialiseInDevFeatures } from "./InDevFeatureFlags";
import "./listenForDateFieldChangeAndUpdateGcSession";
import customerSessionManagement from "./customerSessionManagement";
import "./NavIcon";
import "./storageCleanUp";
import HerWardrobeMessage from "./HerWardrobeMessage";
import { Favourites } from "./Favourites";

import { initialiseBagPage } from "../bag/index";
import { initialiseCheckoutPage } from "../checkout/index";
import { initialiseEmbeddedApp } from "../embedApp/index";
import { initialisePageFeatures } from "./PageFeatures";
import { installStorefrontIndicatorToBody } from "./components/StorefrontIndicator/StorefrontIndicator";
import { initialiseReplacementOfFormKeys } from "./replaceFormKeyUsingSession";
import { initialiseSessionExpirationChecker } from "./sessionExpirationChecker";
import { initialiseLandingPage } from "../landing/index";
import { initialiseProductPage } from "../product/index";

const visitor = Visitor.getInstance();
const page = Page.getInstance();

const isLegacyCataloguePage = !!document.querySelector("#frm_layered_nav");
if (isLegacyCataloguePage) {
  console.log("Legacy Page!");
  GlamCornerCore.bus.broadcast(CatalogueEvents.LegacyMagentoCatalogueLoaded);
}

initialisePageFeatures();

customerSessionManagement();

const inDevFeatures = InDevFeatureFlags.instance();
initialiseInDevFeatures();

const styleSubscriptionAvailabilityService = new StyleSubscriptionAvailabilityService();
const herWardrobeMessage = new HerWardrobeMessage();
const favourites = new Favourites();

initialiseReplacementOfFormKeys(GlamCornerCore.bus);
initialiseSessionExpirationChecker(GlamCornerCore.bus);

function init() {
  initialiseBagPage();
  initialiseCheckoutPage();
  initialiseEmbeddedApp();
  initialiseLandingPage();
  initialiseProductPage();
  installStorefrontIndicatorToBody();
}

init();

export {
  CarouselAddToBagButtonsContainer,
  DATE_PICKER_EVENTS,
  Page,
  Visitor,
  favourites,
  inDevFeatures,
  page,
  herWardrobeMessage,
  styleSubscriptionAvailabilityService,
  visitor,
};
